<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo" style="position: relative;">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" v-shortkey="['esc']" @shortkey="cerrar" variant="danger"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-button v-if="item.activo" type="button" size="sm" class="btn_activar_desactivar_formula"
                variant="outline-dark" @click="modfiicar_estado_formula">Desactivar</b-button>
            <b-button v-else type="button" size="sm" class="btn_activar_desactivar_formula" variant="outline-dark"
                @click="modfiicar_estado_formula">Activar</b-button>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-1">
                        <h3>
                            Editar Promoción
                        </h3>
                    </div>

                    <div :class="ES_ROOT ? 'col-sm-6 mt-3' : 'col-sm-9 mt-3'">
                        <label for="" class="form-label">Nombre de la promoción</label>
                        <input type="text" class="form-control form-control-sm" v-model="nombre_formula">
                    </div>
                    <div v-if="ES_ROOT" class="col-sm-3 mt-3">
                        <label for="" class="form-label">Sucursal Asignada</label>
                        <select class="form-control form-control-sm" required v-model="sucursal"
                            @change="setear_sucursal_origen">
                            <option value="">Seleccionar</option>
                            <option v-for="(item, index) in SUCURSALES_SIN_BODEGA_CENTRAL" :key="index"
                                :value="item.codigo">
                                {{ item.nombre }}</option>
                        </select>
                    </div>
                    <!-- <div class="col-sm-3 mt-3">
                        <label for="" class="form-label">Precio Costo</label>
                        <input type="number" step="0.01" min="0" class="form-control form-control-sm"
                            v-model="precio_costo">
                    </div> -->
                    <div class="col-sm-3 mt-3">
                        <label for="" class="form-label">Precio Venta</label>
                        <input type="text" step="0.01" min="0" class="form-control form-control-sm"
                            v-model="precio_venta">
                    </div>
                    <div class="col-sm-8 mt-3">
                        <label for="" class="form-label">Código producto</label>
                        <input type="text" list="productos_" :disabled="FILTRAR_PRODUCTOS_POR_SUCURSAL.length === 0"
                            autocomplete="off" id="campo_codigo_producto_formula_actualizar"
                            class="form-control form-control-sm" v-model="codigo">
                        <datalist id="productos_">
                            <option v-for="(item, index) in FILTRAR_PRODUCTOS_POR_SUCURSAL" :key="index"
                                :value="item.codigo">{{
                                    item.nombre
                                }}</option>
                        </datalist>
                    </div>

                    <div class="col-sm-2 mt-3">
                        <label for="" class="form-label">Cantidad</label>
                        <input type="number" class="form-control form-control-sm" v-model="cantidad">
                    </div>

                    <div class="col-sm-2 mt-5">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="agregar_producto_a_lista">Agregar</button>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="contenedor_lista_articulos_para_combo">
                            <table class="table table-sm table-striped table-bordered" style="font-size: 11px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%;">
                                            Código
                                        </th>
                                        <th style="width: 65%;">
                                            Descripción
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Cantidad
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            ...
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in listado" :key="index">
                                        <td>
                                            {{ item.codigo }}
                                        </td>
                                        <td>
                                            {{ item.descripcion }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.cantidad }}
                                        </td>
                                        <td style="text-align: center;">
                                            <b-button type="button" size="sm" style="font-size: 9px;"
                                                variant="outline-dark" @click="eliminar_fila(index)"><i
                                                    class="fas fa-trash"></i></b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-sm-12 mt-3 mb-3">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="guardar_formula">Actualizar</button>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'ListadoFormulas',
        props: ['item'],
        computed: {
            ...mapState(['datos_usuario']),
            ...mapGetters(['ES_ROOT', 'FILTRAR_PRODUCTOS_POR_SUCURSAL', 'SUCURSALES_SIN_BODEGA_CENTRAL'])
        },
        data() {
            return {
                listado: [],
                codigo: '',
                cantidad: 1,
                nombre_formula: '',
                precio_costo: '',
                precio_venta: '',
                sucursal: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            agregar_producto_a_lista() {

                if (this.codigo == '' || this.cantidad == '') {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })

                } else {

                    let i = this.FILTRAR_PRODUCTOS_POR_SUCURSAL.findIndex(item => item.codigo == this.codigo)

                    let f = {
                        codigo: this.codigo,
                        descripcion: this.FILTRAR_PRODUCTOS_POR_SUCURSAL[i].nombre,
                        cantidad: this.cantidad <= 0 ? 1 : this.cantidad,
                    }

                    this.listado.push(f)
                    document.getElementById('campo_codigo_producto_formula_actualizar').focus()

                    this.codigo = ''
                    this.cantidad = ''
                }
            },
            eliminar_fila(index) {
                this.listado.splice(index, 1)
            },
            async modfiicar_estado_formula() {
                let f = {
                    api: `articulos/${this.item.documentId}`,
                    formulario: {
                        activo: !this.item.activo
                    }
                }


                await this.actualizar_data(f)
                await this.obtener_articulos()
                await this.cerrar()

            },
            async guardar_formula() {
                if (this.nombre_formula == '' || this.precio_costo == '' || this.precio_venta == '') {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                } else {
                    if (this.listado.length == 0) {
                        minix({ icon: 'error', mensaje: 'La formula debe tener al menos un producto', tiempo: 3000 })
                    } else {

                        let f = {
                            api: `articulos/${this.item.documentId}`,
                            formulario: {
                                nombre: this.nombre_formula,
                                elementos_formula: this.listado,
                                precio_costo: this.precio_costo,
                                precio_venta: this.precio_venta,
                                precio_efectivo: this.precio_venta,
                                sucursal: this.ES_ROOT ? this.sucursal : this.datos_usuario.sucursal_asignada
                            }
                        }

                        await this.actualizar_data(f)
                        await this.obtener_articulos()
                        await this.cerrar()

                    }
                }
            },
            setear_sucursal_origen() {
                // ESTO ES PARA QUE FILTRE LOS PRODUCTOS POR SUCURSAL
                this.set_filtro_productos_sucursales_traslados(this.sucursal)

            },
            ...mapActions(['actualizar_data', 'obtener_articulos']),
            ...mapMutations(['set_filtro_productos_sucursales_traslados'])
        },
        mounted() {
            document.getElementById('campo_codigo_producto_formula_actualizar').focus()

            this.nombre_formula = this.item.nombre
            this.precio_costo = this.item.precio_costo
            this.precio_venta = this.item.precio_venta
            this.sucursal = this.item.sucursal

            this.listado = this.item.elementos_formula

            this.setear_sucursal_origen()
        },

    }
</script>

<style>
    .btn_activar_desactivar_formula {
        position: absolute;
        right: 20px;
        top: 50px;
        z-index: 999;
    }
</style>